<script lang="ts" setup>
// import generationPPtJson from "../useTemp/index";

import { step, answer, done, showLodingDialog } from "../use/data";
import { resendMsg, goBackTotheme, stopSendMsg } from "../use/methods";
import { watch, nextTick } from "vue";
import CsdVditor from "@/components/global/vditor/Vditor.vue";
import EditNode from "../components/editNode.vue";
import _ from "lodash";
import useStore from "@/stores/publicStore";
import { storeToRefs } from "pinia";
import { showMessageBoxByType } from "@/components/content/MessageBox/messageBox";
import { openLoginDialog } from "@/components/content/loginDialog/login";

const { isVip, isLogin, tryOut } = storeToRefs(useStore());
watch(answer, () => {
  scrollToBottom();
});

const divContent: Ref<null | HTMLDivElement> = ref(null);

const changeOutline = () => {
  if (!isLogin.value) {
    ElMessage.warning("请先登录");
    openLoginDialog();
    return;
  }
  if (!isVip.value && tryOut.value) {
    showMessageBoxByType("changeOutline");
    return;
  }
  resendMsg();
};

const scrollToBottom = _.throttle(function () {
  nextTick(() => {
    if (divContent.value) {
      divContent.value.scrollTop = divContent.value.scrollHeight;
    }
  });
}, 500);

const selectTemplate = () => {
  if (!done.value) {
    ElMessage.warning("请耐心等待大纲生成");
    return;
  }
  if (!isVip.value && tryOut.value) {
    showMessageBoxByType("generationPPT");
    return;
  }
  step.value = "template";
};
onUnmounted(() => {
  showLodingDialog.value = false;
  // answer.value = "";
  done.value = true;
  stopSendMsg();
});
</script>

<template>
  <div class="slide-ppt-generation">
    <div class="slide-ppt-generation-main">
      <div class="absolute">
        <div class="white-button px-15 py-10 rounded-20" @click="goBackTotheme">
          <span class="iconfont ppt-back mr-5 !text-12"></span>
          返回
        </div>
      </div>
      <div class="slide-ppt-generation-main-content">
        <div class="answer-content">
          <div
            class="answer-content-vditor"
            :style="{ 'background-color': done ? '#FBFBFB' : '#fff' }"
          >
            <div class="full relative">
              <div class="loading-gif" v-if="answer === ''">
                <CsdImg :src="`/images/ppt/loading.gif`" class="size-160" />
                正在为你生成PPT大纲，大纲完成后将制作PPT文件
              </div>
              <div class="answer-content-vditor-body">
                <div ref="divContent" class="scroll hide-x-scrollbar" h-full>
                  <CsdVditor
                    :id="`slidePPT-generation`"
                    :content="answer"
                    v-if="!done"
                  />
                  <EditNode v-if="done" />
                </div>
              </div>
            </div>
          </div>
          <div class="answer-content-footer">
            <div class="switching-outline" @click="changeOutline">
              <!-- :class="{ 'gray-btn': !done }" -->
              <span class="iconfont ppt-switch-refresh mr-5 !text-12"></span>
              换个大纲
            </div>
            <div
              class="next-step"
              :class="{ 'gray-btn': !done }"
              @click="selectTemplate"
            >
              生成 PPT
            </div>
          </div>
        </div>
      </div>
    </div>
    <CsdDialog :showDialog="showLodingDialog">
      <div class="py-28 px-45 bg-#FFFFFF">
        <CsdImg src="/images/ppt/loading.gif" class="size-120" />
        <div class="flex-center mt-16">模块加载中 ...</div>
      </div>
    </CsdDialog>
  </div>
</template>

<style lang="scss">
.slide-ppt-generation {
  width: 100%;
  height: 100%;
  padding: 15px;
  background-color: aquamarine;
  background: linear-gradient(180deg, #e1f5ff 0%, #ffffff 27%, #ffffff 100%);
  position: relative;

  &-main {
    z-index: 2;
    position: relative;
    width: 100%;
    height: 100%;

    &-content {
      color: #333;
      font-size: 14px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .answer-content {
        width: 524px;
        height: 670px;
        max-height: calc(100vh - 60px);
        overflow: hidden;
        background-color: white;
        border-radius: 10px 10px 10px 10px;
        box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.16);
        padding: 20px 15px;
        display: flex;
        flex-direction: column;

        &-vditor {
          border-radius: 6px;
          flex: 1;
          overflow: hidden;
          padding: 10px;
          position: relative;
          border: 1px solid #eff0f1;

          .loading-gif {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            white-space: nowrap;
          }

          &-body {
            height: 100%;
          }
        }

        &-footer {
          display: flex;
          margin-top: 20px;
          justify-content: space-between;
          font-size: 14px;

          .gray-btn {
            filter: grayscale(1);
            cursor: not-allowed !important;
          }

          .switching-outline {
            padding: 10px 20px;
            border-radius: 5px;
            border: 1px #4c83fc solid;
            margin-right: 20px;
            color: #4c83fc;
            cursor: pointer;

            &:hover {
              color: #4c83fcbb;
              border-color: #4c83fcbb;
            }

            &:active {
              color: #4c83fc;
              border-color: #4c83fc;
            }
          }

          .next-step {
            flex: 1;
            padding-top: 10px;
            padding-bottom: 10px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            background: linear-gradient(90deg, #13dce6 0%, #528af6 100%);
            cursor: pointer;

            &:hover {
              background: linear-gradient(90deg, #13dce699 0%, #528af699 100%);
            }

            &:active {
              background: linear-gradient(90deg, #13dce6 0%, #528af6 100%);
            }
          }
        }
      }
    }
  }
}
</style>
